import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() title?: string;
  @Input() description?: string;
  @Input() iconSrc?: string;
  @Input() isEditIcon?: boolean = false;
  @Input() isCollapsible?: boolean = false;
  @Input() noBorder: boolean = false;
  @Output() editIconClicked = new EventEmitter();

  isContentVisible = true;

  toggleVisibleState(): void {
    this.isContentVisible = !this.isContentVisible;
  }
}
